import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@chakra-ui/react'

const NoWrapCell = ({getValue, className}) => {
  const value = getValue()

  return (
    <Text whiteSpace="nowrap" className={className}>
      {value}
    </Text>
  )
}

NoWrapCell.defaultProps = {
  className: undefined,
}

NoWrapCell.propTypes = {
  getValue: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default NoWrapCell
